module.exports = __webpack_public_path__ + "static/media/Icon_menu_cleaning_products.6c2f1ad8.svg";